/* eslint-disable @typescript-eslint/no-explicit-any */
import * as axios from "axios";
import QGContext from "../../QGContext";
import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";

/**
 * Gets the validation sets from the Quality Gate API
 *
 * @param {string} projectId The project ID
 * @returns {Promise<any>} The validation sets from the Quality Gate API
 */
export const useGetValidationSets = (projectId: string | null | undefined) => 
{
  const ctx = useContext(QGContext);

  // TODO typing
  return useQuery<any, any>({
    queryKey: ["getValidationSets", projectId],
    queryFn: async () => 
    {
      const response = await axios.default.get(
        `/qualitygate/v1/validationSets/${projectId}`,
        {
          headers: {
            userToken: ctx.tokens.idToken,
            accessToken: ctx.tokens.accessToken,
          },
        },
      );
      return response.data;
    },
    enabled: !!projectId,
  });
};